// extracted by mini-css-extract-plugin
export default {"confirmModal":"GroupTalkTextModal_confirmModal__0gKfT"};